const dotenv = require('dotenv');
dotenv.config();

module.exports = {
  environment: process.env.VUE_APP_NODE_ENV,
  endpoint: process.env.VUE_APP_API_URL,
  port: process.env.VUE_APP_PORT,
  activationFee: process.env.VUE_APP_ACTIVATION_FEE
};
